/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITSTATE = {
    tripPlannerAggregations: {
        aggregations: {},
    },
};

export default function tripPlanner(state = INITSTATE, action) {
    let st = state;

    switch (action.type) {
        case types.GET_TRIP_PLANNER_SEARCH_ERROR:
            st = { ...state };
            st.err = action.err;
            return st;

        case types.GET_TRIP_PLANNER_AGGREGATIONS:
            st = { ...state };
            if (action.payload.aggregations) {
                st[action.uiFilterName] = action.payload.aggregations;
            } else {
                st[action.uiFilterName] = {};
            }
            delete st.err;
            return st;
        case types.GET_TRIP_PLANNER_GROUP_AGGREGATIONS:
            st = { ...state };
            if (action.aggregations) {
                st[action.groupName] = action.aggregations;
            } else {
                st[action.groupName] = {};
            }
            delete st.err;
            return st;
        case types.GET_TRIP_PLANNER_RESET_AGGREGATIONS:
            return {};

        default:
            return st;
    }
}
